import React from "react";
import Media from "@qlik/qlik/src/components/Media";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";
import * as styles from "./styles.module.css";

/**
 * Awards component.
 * Renders a section with a title and a list of cards.
 * Each card contains an image, a title and a subtitle.
 * @param {Object} props - The component props.
 * @param {Object} props.data - The data for the awards section.
 * @returns {JSX.Element} The rendered component.
 */
const Awards = ({ data }) => {
    const { additionalConfiguration, title, cardItems = [], customId } = data ?? {};
    // Get the class name for the section padding
    const sectionPaddingClassName = getSpacingClassName(additionalConfiguration, " md:pt-20 md:pb-30 py-5");

    return (
        <section className={`${sectionPaddingClassName}`} id={customId}>
            <div className="container">
                <div className="row">
                    <h2 className="mb-15 text-center tracking-tight10 font-semibold leading-tight text-blue">
                        {title}
                    </h2>
                    {/* Map over the card items and render each one */}
                    {cardItems.map((card) => (
                        <div key={card.id} className={`col-12 md:col-6 ${styles.wrapper}`}>
                            <div className={`flex flex-row justify-start h-[184px] ${styles.imageWrapper}`}>
                                {/* Render the media component if the card has media */}
                                {card.media?.[0] && (
                                    <Media
                                        media={card.media?.[0]}
                                        className="mr-7.5 object-contain h-full max-w-[155px]"
                                    />
                                )}
                                <div className="flex flex-col self-center gap-3.75">
                                    {/* Render the card title if it exists */}
                                    {card?.title && (
                                        <h3 className="font-semibold text-blue md:text-5xl tracking-tight9 leading-tight">
                                            {card?.title}
                                        </h3>
                                    )}
                                    {/* Render the card subtitle if it exists */}
                                    {card?.subtitle && (
                                        <h4 className="font-semibold text-gray  md:text-3xl	tracking-tight10 leading-tight">
                                            {card?.subtitle}
                                        </h4>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

// Export the Awards component as the default export
export default Awards;
